import {
  CountryMarketConfig,
  Language,
} from '../../common/CountryMarketConfig';
import { Taxonomies } from '../../types/briefing';
import { TaxonomyState } from './TaxonomyState';

export const getAvailableTaxonomiesFromState = (
  taxonomyState: TaxonomyState,
  countryMarketConfig: CountryMarketConfig | null | undefined,
  language: Language,
): Taxonomies =>
  (countryMarketConfig &&
    taxonomyState[countryMarketConfig.taxonomyMarketAbbreviaton]?.[language]
      ?.taxonomies) ||
  {};
